/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var JoinAnalyticsSortByColumnEnum;

(function (JoinAnalyticsSortByColumnEnum) {
  JoinAnalyticsSortByColumnEnum["CREATED_AT"] = "created_at";
  JoinAnalyticsSortByColumnEnum["EMAIL_VIEWED_TIMES"] = "email_viewed_times";
  JoinAnalyticsSortByColumnEnum["QUOTE_VIEWED_TIMES"] = "quote_viewed_times";
  JoinAnalyticsSortByColumnEnum["CONTRACT_START_DATE"] = "contract_start_date";
  JoinAnalyticsSortByColumnEnum["UPDATED_AT"] = "updated_at";
  JoinAnalyticsSortByColumnEnum["PURCHASED_AT"] = "purchased_at";
})(JoinAnalyticsSortByColumnEnum || (JoinAnalyticsSortByColumnEnum = {}));